import { connect } from 'react-redux';
import { CreateInstitutionPage } from './component';
import { ROUTE_INSTITUTION_ADMIN } from '../../../ReduxStorage/routeActions';

export const ConnectedCreateInstitutionPage = connect(null, (dispatch) => ({
  onPortalCreated: (name: string) =>
    dispatch({
      type: ROUTE_INSTITUTION_ADMIN,
      query: {
        institution: name,
        action: 'courses',
      },
    }),
}))(CreateInstitutionPage);
